import React from 'react'

import { compose, withProps } from 'recompose'
import { withGoogleMap, GoogleMap, withScriptjs } from 'react-google-maps'

const MapComponent = (props) => {
    return (
        <GoogleMap defaultZoom={15} defaultCenter={{ lat: 39.7685, lng: -86.158 }} {...props}>
            {props.children}
        </GoogleMap>
    )
}

MapComponent.propTypes = {}

export default compose(
    withProps({
        googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA1pLzWaz2ldFHYXZRoLjib-Dt-i5sGJ2E&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{ height: '100%' }} />,
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '100%' }} />,
    }),
    withScriptjs,
    withGoogleMap
)(MapComponent)
